<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-3 page-title">
            <h3 class="text-center mt-2 mal-text custom-title">{{ displayTitle }}</h3>
        </div>
    </div>

    <div class="section text-center" v-if="loading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>

    <div class="section pt-1 pb-3" v-else-if="hasProgram">
        <div class="card sneha-intro-card">
            <div class="card-body">
                <div v-if="program.intro_text" class="sneha-intro-text mal-text">{{ program.intro_text }}</div>
                <p v-else class="sneha-intro-empty-text mal-text">പദ്ധതി വിശദാംശങ്ങൾ താഴെ നിന്ന് അപേക്ഷ തുടരുക.</p>
                <router-link
                    :to="applyPath"
                    class="btn btn-primary btn-block btn-lg mal-text sneha-apply-btn"
                >
                    അപേക്ഷയിലേക്ക് പോകുക
                </router-link>
            </div>
        </div>
    </div>

    <div class="section pt-2" v-else>
        <p class="text-center text-muted mal-text mb-0">പദ്ധതി വിവരങ്ങൾ ലഭ്യമല്ല.</p>
    </div>
</template>

<script>
import UserService from "@/services/user.service";

export default {
    name: "SnehaSparshamIntro",
    data() {
        return {
            loading: true,
            program: {},
            loadFailed: false,
        };
    },
    computed: {
        programId() {
            const fromProgram = this.program.id ?? this.program.program_id;
            if (fromProgram) {
                return parseInt(fromProgram, 10);
            }
            const fromRoute = parseInt(this.$route.params.program_id, 10);
            return Number.isFinite(fromRoute) ? fromRoute : null;
        },
        hasProgram() {
            return !this.loadFailed && (
                !!this.programId ||
                !!this.program.title ||
                !!this.program.intro_text
            );
        },
        displayTitle() {
            return this.program.title || this.program.button_label || "സ്നേഹ സ്പർശം";
        },
        applyPath() {
            return `/org/${this.$route.params.sub_level}/${this.$route.params.id}/sneha-sparsham/${this.programId}/apply`;
        },
    },
    watch: {
        "$route.params.program_id"() {
            this.loadProgram();
        },
    },
    mounted() {
        this.$root.updateParent("സ്നേഹ സ്പർശം");
        this.loadProgram();
    },
    methods: {
        normalizeProgram(raw) {
            if (!raw || typeof raw !== "object") {
                return {};
            }
            const id = raw.id ?? raw.program_id;
            return {
                ...raw,
                id: id != null ? parseInt(id, 10) : null,
            };
        },
        loadProgram() {
            this.loading = true;
            this.loadFailed = false;
            this.program = {};

            const programId = parseInt(this.$route.params.program_id, 10);
            if (!Number.isFinite(programId)) {
                this.loading = false;
                this.loadFailed = true;
                return;
            }

            UserService.authPostRequest("get-sneha-sparsham-program", {
                program_id: programId,
                user_level: parseInt(this.$route.params.sub_level, 10),
                user_level_id: parseInt(this.$route.params.id, 10),
            }).then((res) => {
                this.loading = false;
                if (res.data.status === "success") {
                    const data = res.data.data || {};
                    const raw = data.program || data;
                    this.program = this.normalizeProgram(raw);
                    if (!this.program.id) {
                        this.program.id = programId;
                    }
                    return;
                }
                this.loadFailed = true;
            }).catch(() => {
                this.loading = false;
                this.loadFailed = true;
            });
        },
    },
};
</script>

<style scoped>
.sneha-intro-card {
    border-radius: 10px;
    border: 1px solid #e9ecef;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.sneha-intro-text {
    white-space: pre-wrap;
    font-size: 0.95rem;
    line-height: 1.6;
    color: #333333;
    margin-bottom: 20px;
}

.sneha-intro-empty-text {
    font-size: 0.9rem;
    color: #6c757d;
    margin-bottom: 20px;
}

.sneha-apply-btn {
    font-weight: 600;
}
</style>
